<template>
  <div class="container scroll" style="height: 100vh;overflow-y: auto" @scroll="onScroll" ref="wrap">
    <div class="align-vertical">
      <div class="logo" style="position: relative; width: 885px !important;">
<!--        <b-img style="width: 4em; height: 4em; margin-right: 1.2em;" :src="require('../../../../assets/image/ic_logo1@2x.png')" @click="getHomeData(); initNotifyList()"/>-->
        <b-img class="mt-3 mb-3" style="width: 4em; height: 4em; margin-right: 1.2em;" :src="require('../../../../assets/image/ic_logo@2x.png')" @click="onRefresh"/>
        <div class="logo-title" v-if="homeSetting.f_home_content_type == 'T'" @click="onHomeLink()">{{homeSetting.f_home_content}}</div>
        <b-img v-else :src="homeSetting.f_home_content" class="home_img" @click="onHomeLink()"/>
        <div class="badge_tail badge_finish" @click="showHomeAdPopupProc()"/>
        <div class="badge" @click="showHomeAdPopupProc()">
          <span class="badge_text">{{$t('home.popup')}}</span>
        </div>
      </div>
      <b-input-group>
        <b-form-input :placeholder="placeholder" v-model="keyword" class="search_input"
                      @keydown.enter="onSearch"
        ></b-form-input>
        <b-input-group-append>
          <b-button variant="white" @click="onSearch">
            <b-icon icon="search" variant="primary" style="width:26px; height:28px;"></b-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <div class="row">
        <div style="width: 50%; padding-right: 5px">
          <div class="site_header">
            <div>
              {{$t('home.new_open_site')}}
              <b-button @click="onMonthlySale" variant="white" class="monthly_site_wrapper">{{$t('home.monthly_site')}}</b-button>
            </div>
            <b-button @click="showRegionPopup = true" variant="white" class="regional_setting">{{$t('home.regional_setting')}} <b-icon icon='chevron-right' style="width: 20px; height: 20px;"></b-icon></b-button>
          </div>
          <div class=""
               v-if="siteList.length > 0"
               @mousedown="simpleDown"
               @mousemove="simpleMove"
               @mouseup="simpleUp"
               @mouseout="simpleUp"
               @mouseover="simpleOver"
               @wheel="simpleWheel"
               ref="simple_container"
               tabindex="0"
          >
            <div style="display: flex; flex-wrap: wrap">
              <SiteSimpleItem
                v-for="(item, idx) in siteList"
                :id="idx"
                :item="item"/>
            </div>
          </div>
        </div>
        <div style="width: 50%; padding-left: 5px">
          <div class="site_header">
            {{$t('home.location_noti')}}
            <b-button @click="onTodayNotify"
                      variant="white" class="regional_setting">{{$t('home.today_reminder')}} <b-icon icon='chevron-right' style="width: 20px; height: 20px;"></b-icon></b-button>
          </div>
          <div class="align-vertical" style="">
            <NotifyItem
              v-for="item in notifyList"
              :item="item"
              :hide-red-dot="true"
              @click="onNotifyItem(item)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="quick_btn_wrapper" style="margin-left: 800px">
      <!-- <b-button
        pill
        class="quick_btn align-horizontal center p-0"
        style="background-color: transparent"
        @click="showHomeAdPopupProc()"
      >
        <b-img :src="require('../../../../assets/image/ic_qb_popup_banner@2x.png')"/>
      </b-button> -->
      <b-button
        pill
        class="quick_btn align-horizontal center p-0"
        style="background-color: transparent"
        @click="showSearchDlg()"
      >
        <b-img :src="require('../../../../assets/image/ic_qb_search@2x.png')"/>
      </b-button>
      <b-button
        pill
        class="quick_btn align-horizontal center p-0"
        style="background-color: transparent"
        @click="
          $store.commit('setTabIndex', self.$c.MAIN_TAB.MORE);
          $store.commit('setTmpTabIndex', '');
          ut.navigate(self, '/SaleList');"
      >
        <b-img :src="require('../../../../assets/image/ic_qb_sale_list@2x.png')"/>
      </b-button>
      <b-button
        pill
        class="quick_btn align-horizontal center p-0"
        style="background-color: transparent"
        @click="showSaleRegisterPopup = true"
      >
        <b-img :src="require('../../../../assets/image/ic_qb_sale_regist@2x.png')"/>
      </b-button>
    </div>
    <Navbar />
    <Gallery
      :src="imgList"
      :current="activeIndex"
      :visible.sync="showGallery"
    />
    <NotifyDetailPopup
      :item="notify"
      :visible.sync="showNotifyPopup"
    />
    <MonthlySalePopup
      :visible.sync="showMonthPopup"
    />
    <RegionalSettingPopup
      :visible.sync="showRegionPopup"
      @cancel="getHomeData"
    />
    <CommunityDetailPopup
      :visible.sync="showCommunityDetailPopup"
      :info="communityData"
      :onDelete="onDeleteCommunity"
      :onEdit="onEditCommunity"
    />
    <CommunityCreatePopup
      :visible.sync="showCommunityCreatePopup"
      :info="communityData"
    />
    <SiteDetail v-if="siteDetailData != null" :visible.sync="showSiteDetailPopup" :site="siteDetailData" />
    <SiteRegisterPopup :visible.sync="showSaleRegisterPopup" />
    <HomeAdPopup :visible.sync="showHomeAdPopup" :ads-list="adsList" :home-setting="homeSetting" :on-site-detail="onSiteDetail" :on-community-detail="onCommunityDetail" @adTime="myinfo.loadInfo()"/>
    <SearchPopup :visible.sync="showSearchPopup" @search="onSearchPopup"/>
    <SiteInquiry v-if="inquiryKeyword != null" :visible.sync="showSiteInquiryPopup" :keyword="inquiryKeyword" />
  </div>
</template>

<script>

import Utils from '../../../../config/utils.js';
import Navbar from '../../../controls/navbar';
import Gallery from "../../../controls/Gallery";
import NotifyItem from "../../../controls/NotifyItem";
import NotifyDetailPopup from "../../../controls/popup/NotifyDetailPopup";
import MonthlySalePopup from "../../../controls/popup/MonthlySalePopup";
import RegionalSettingPopup from "../../../controls/popup/RegionalSettingPopup";
import CommunityDetailPopup from "../../../controls/popup/CommunityDetailPopup";
import CommunityCreatePopup from "../../../controls/popup/CommunityCreatePopup";
import SiteSimpleItem from "../../../controls/SiteSimpleItem";
import SiteDetail from "../interest/SiteDetail";
import CCarousel from "../../../controls/CCarousel";
import Vue from "vue";
import SiteRegisterPopup from "../../../controls/popup/SiteRegisterPopup";
import moment from "moment";
import HomeAdPopup from "../../../controls/popup/HomeAdPopup.vue";
import SearchPopup from "../../../controls/popup/SearchPopup.vue";
import SiteInquiry from '../interest/SiteInquiry.vue';
// import VueGeolocationApi from "vue-geolocation-api";
// Vue.use(VueGeolocationApi /*, { ...options } */);

export default {
  name: "Home",
  components: {
    HomeAdPopup,
    SearchPopup,
    SiteRegisterPopup,
    Navbar,
    Gallery,
    NotifyItem,
    NotifyDetailPopup,
    MonthlySalePopup,
    RegionalSettingPopup,
    CommunityDetailPopup,
    CommunityCreatePopup,
    SiteSimpleItem,
    SiteDetail,
    SiteInquiry,
    CCarousel
  },
  inject: ["eventBus"],
  data: function() {
    return {
      keyword: '',
      placeholder: '',
      homeSetting: {},
      adsList: [],
      siteList: [],
      notifyList: [],
      pageNum: 1,
      loadingEnd: false,
      activeIndex: 0,
      showRegionPopup: false,
      showNotifyPopup: false,
      showCommunityDetailPopup: false,
      showCommunityCreatePopup: false,
      communityData: null,
      notify: null,
      showExtendPopup: false,
      community: null,
      showMonthPopup: false,
      showGallery:false,
      imgList:[],
      showSiteDetailPopup:false,
      showSaleRegisterPopup:false,
      showHomeAdPopup:false,
      showSearchPopup:false,
      siteDetailData:null,
      showSiteInquiryPopup:false,
      inquiryKeyword:null,
      simple_down:false,
      offset:0,
      self: this,
      ut: Utils
    };
  },
  mounted() {
    this.myinfo.loadInfo();
    this.$store.commit('setTabIndex', this.$c.MAIN_TAB.HOME);
    // // TODO: 위치정보
    this.myinfo.latitude=37.51762440574381;
    this.myinfo.longitude=126.95891619231263;
    // //
    this.getHomeData(true);
    this.initNotifyList();

    // // TODO: 위치정보
    // this.myinfo.latitude = 37.566826;
    // this.myinfo.longitude = 126.9786567;
    this.getLocation();
    if(this.$store.getters.goSale)
      this.getNearExpireSalesCount();
  },
  beforeDestroy() {
    clearInterval(this.ads_interval);
  },
  beforeRouteLeave (to, from, next) {
    if (to.path !== '/Login' && to.path !== '/' && to.path !== '/Splash')
      next();
  },
  methods: {
    getNearExpireSalesCount () {
      if (this.$store.state.isLoading)
        return;
      Utils.requestGet(
        this.$c.API.Site.getMySiteList,
        {
          site_type: 'G',
          page_num: 0,
          only_near_expire_sales_count: 'Y',
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          if (result.data.list.f_cnt_near_expire > 0) {
            Utils.showConfirm2(this,
              '<p style="font-size: 20px;">'+this.$t('common.update_maemul_title') +'</p>' +
              '<p style="font-size: 20px; color:#cf0000;margin-bottom: 0px;">'+this.$t('common.update_maemul_environment') +'</p>'
            ).then(
              (val) => {
                if(val){
                  this.$store.commit('setTabIndex', this.$c.MAIN_TAB.MORE);
                  this.$store.commit('setGoSale', false);
                  this.$router.push('/SaleList')
                }
              }
            )
          }
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    onRefresh(){
      window.location.href='/'
    },
    simpleDown(e){
      e.preventDefault();
      this.simple_down = true;
    },
    simpleUp(){
      this.simple_down = false;
    },
    simpleOver(){
      console.log("over");
      // this.$refs.simple_container.focus();
    },
    simpleWheel(e){
      // e.preventDefault();
      // this.$refs.simple_container.scrollLeft = this.$refs.simple_container.scrollLeft + e.deltaY;
    },
    simpleMove(e){
      if (this.simple_down){
        this.$refs.simple_container.scrollLeft = this.$refs.simple_container.scrollLeft - e.movementX;
      }
    },

    onScroll(){
      if (this.notifyList.length === 0)
        return;
      else {
        let wrap = this.$refs.wrap;
        if(wrap.scrollHeight - Math.ceil(wrap.scrollTop) === wrap.clientHeight){ //end of scroll
          if (!this.loadingEnd){
            this.getNotifyList();
          }
        }
      }

    },

    onSearchPopup(item) {
      this.inquiryKeyword = item;
      this.showSiteInquiryPopup = true;
    },

    onSearch() {
      this.eventBus.$emit("checkTicketAvailable", ()=>{
        this.$store.commit('setFilter',{keyword : this.keyword});
        Utils.navigate(this, '/map');
      });
    },

    onSiteDetail(data) {
      this.siteDetailData = data;
      this.showSiteDetailPopup = true;
    },

    onCommunityDetail(data) {
      this.communityData = data;
      this.showCommunityDetailPopup = true;
    },

    onMonthlySale(){
      /*let usage_date = moment(this.myinfo.usageDate);
      if ((usage_date.isValid() && usage_date.diff(moment(), 'd') >= 0) || this.myinfo.setting.ticket_price === 'F') {
        this.eventBus.$emit('checkTicketAvailable', ()=>{
          this.showMonthPopup = true;
        })
        return;
      }

      Utils.showConfirm(
        this,
        this.$t("home.usage_date_limited")
      ).then((val) => {
          if(val){
            this.eventBus.$emit('checkTicketAvailable', ()=>{
              this.showMonthPopup = true;
            })
          }
        }
      );*/
      this.eventBus.$emit('checkTicketAvailable', ()=>{
        this.showMonthPopup = true;
      })
      // Utils.toast(this, this.$t('home.usage_date_limited'));
    },
    onDeleteCommunity(){
      Utils.toast(this, this.$t('common.delete_success'));
      this.showCommunityDetailPopup = false;
    },

    onEditCommunity(){
      this.showCommunityDetailPopup=false;
      this.showCommunityCreatePopup=true;
    },
    onRegionSetting(){

    },
    onTodayNotify(){
      this.$store.commit('setTodayNotifyList', true);
      Utils.navigate(this,'/notify/today');
    },

    getHomeData: function (updateSlideShow=false) {
      console.log('---------------------------------------------')
      Utils.requestGet(this.$c.API.User.getHomeData, {}, false).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.placeholder = result.data.home_setting.f_home_search_hint;
          this.homeSetting = result.data.home_setting;
          this.adsList = result.data.ads;
          this.siteList = result.data.interest_sites;

          /*if (updateSlideShow)
            this.randomSlideShowAdsImages();*/
          this.showHomeAdPopup = (this.ut.getCurrentTime() >= this.myinfo.homeAdDate);
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    getLocation: function () {
      this.myinfo.latitude = 37.51762440574381;
      this.myinfo.longitude = 126.95891619231263;
      console.log("==========get location ====");
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            console.log(pos);
            this.myinfo.latitude = pos.coords.latitude;
            this.myinfo.longitude = pos.coords.longitude;
          },
          (err) => {
            console.log(err.message);
            this.myinfo.latitude = 37.51762440574381;
            this.myinfo.longitude = 126.95891619231263;
          }
        );
      }
    },

    initNotifyList: function() {
      this.notifyList = [];
      this.pageNum = 1;
      this.loadingEnd = false;
      this.getNotifyList();
    },
    getNotifyList: function() {
      if (this.$store.getters.isLoading) {
        return;
      }

      if (this.loadingEnd) {
        return;
      }

      Utils.requestGet(this.$c.API.Notify.getNotifyList, {
        page_num: this.pageNum,
        column: '',
        keyword: ''
      }).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.notifyList = this.notifyList.concat(result.data.list);
          this.loadingEnd = result.data.limit > result.data.list.length;
          this.pageNum += 1;
          this.checkPushData();
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    onHomeLink: function() {
      let homeSetting = this.homeSetting;
      switch (homeSetting.f_home_link_type) {
        case 'S':
          this.go2SiteDetail(homeSetting.f_home_link_data);
          break;
        case 'C':
          Utils.requestGet(this.$c.API.Community.getCommunityDetail, {
            community_idx: homeSetting.f_home_link_data,
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              this.community = result.data;
              this.showCommunityDetailPopup = true;
            } else {
              Utils.toast(this, result.msg);
            }
          });
          break;
        case 'I':
          if (!homeSetting.f_home_link_data.startsWith('http')) {
            homeSetting.f_home_link_data = 'http://' + homeSetting.f_home_link_data;
          }
          this.imgList = [homeSetting.f_home_link_data];
          this.showGallery = true;
          break;
        case 'L':
          if (!homeSetting.f_home_link_data.startsWith('http')) {
            homeSetting.f_home_link_data = 'http://' + homeSetting.f_home_link_data;
          }
          // TODO:
          window.open(homeSetting.f_home_link_data,'_blank');
          break;
      }
    },

    go2SiteDetail(siteIdx){
      Utils.requestGet(
        this.$c.API.Site.getSiteDetail,
        {
          site_idx: siteIdx,
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.siteDetailData = result.data;
          this.showSiteDetailPopup = true;
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },

    checkPushData: function() {
      if (this.myinfo.pushType != 0) {
        if (this.myinfo.pushType == "7" || this.myinfo.pushType == "6") {
          Utils.requestGet(this.$c.API.Community.getCommunityDetail, {
            community_idx: this.myinfo.pushUid,
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              Utils.setState(this,{
                community: result.data,
                showCommunityDetailPopup: true,
              });
            } else {
              Utils.toast(this, result.msg);
            }
          });
        } else if (this.myinfo.pushType == "3") {
          Utils.requestGet(this.$c.API.Notify.getNotifyDetail, {
              notify_idx: this.myinfo.pushUid,
          }).then((result) => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                this.showNotifyPopup = true;
                this.notify = result.data.info;
            } else {
              Utils.toast(this, result.msg);
            }
          });
        }
        this.$store.commit('setMyInfo', {pushType: 0});
      }
    },

    onNotifyItem(noti){
      if (noti.f_read === 'N') {
        Utils.requestPost(this.$c.API.Notify.setRead, {
          notify_idx: noti.f_idx,
        }).then(
          (result)=>{
            if (result.code === this.$c.API_RES_CODE.SUCCESS) {
                this.notifyList = this.notifyList.map(it => {
                  if (noti.f_idx == it.f_idx) {
                    it.f_read = 'Y';
                  }
                  return it;
                });
            } else {
              Utils.toast(this, result.msg);
            }
          }
        );
      }
      this.notify= noti;
      this.showNotifyPopup = true;
    },

    showHomeAdPopupProc() {
      this.myinfo.homeAdDate = this.ut.getCurrentTime();
      this.$perf.setString('homeAdDate', this.myinfo.homeAdDate);
      this.showHomeAdPopup = true;
    },

    showSearchDlg() {
      this.showSearchPopup = true;
    }
  },
}
</script>

<style scoped lang="scss">
@import '../../../../assets/css/main/home/Home.scss';
.site_list{
  width: 100%;
  height: 225px;
  overflow-x: scroll;
}
.logo-title{
  font-family: $korean_gd_14_r;
  font-size: $fs_26;
  padding-top: calc(1rem + 0.5em);
}
.search_input{
  height: 40px;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
  padding-left: 10px;
  padding-top: 3px;
}

.site_list:focus{
  outline: none!important;
}

.badge {
  cursor: pointer;
  position: absolute !important;
  top: 13px;
  right: 3px;
  padding-right: 3px;

  /** Rotation */
  -webkit-transform: rotate(45deg); 
  -moz-transform: rotate(45deg);    
  transform:rotate(45deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
}

.badge_text {
  cursor: pointer;
  color: $white;
  font-size: 19px;
  font-family: $korean_gd_12_r;
  margin-top: 4px;
  margin-right: 2px;
}

.badge_finish {
  cursor: pointer;
  border-top-color: $primary;
}

.badge_tail {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  background-color: transparent;
  border-style: solid;
  border-left-width: 75px;
  border-right-width: 0;
  border-top-width: 70px;
  border-bottom-width: 0;
  border-left-color: transparent;
  border-right-color: transparent;
}

</style>



// WEBPACK FOOTER //
// src/components/contents/main/home/Home.vue